// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__3WLd8","actionColumn":"ReferralSources_actionColumn__rltwu","textButton":"ReferralSources_textButton__1ohMF"};